import { matchPath } from "react-router";
import type { ReactPermissionRoute } from "@/stores/react/authStore";

/** 按完整路由模式查找当前菜单节点，兼容包含动态参数的隐藏页面。 */
const findCurrentRoute = (routes: ReactPermissionRoute[], pathname: string): ReactPermissionRoute | undefined => {
    for (const route of routes) {
        if (route.path && matchPath({ path: route.path, end: true }, pathname)) {
            return route;
        }

        const child = findCurrentRoute(route.children || [], pathname);
        if (child) {
            return child;
        }
    }

    return undefined;
};

/** 对齐 Vue 的 `route.meta.activeMenu || route.name`，统一得到布局实际选中路径。 */
export const resolveActiveMenuPath = (routes: ReactPermissionRoute[], pathname: string) => {
    const activeMenu = findCurrentRoute(routes, pathname)?.meta?.activeMenu;
    return typeof activeMenu === "string" && activeMenu ? activeMenu : pathname;
};
